import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../auth/msalConfig';
import Header from '../Header/Header';
import { McButton } from '@maersk-global/mds-react-wrapper/components-core/mc-button';
import { McIcon } from '@maersk-global/mds-react-wrapper/components-core/mc-icon';
import { McNotification } from '@maersk-global/mds-react-wrapper/components-core/mc-notification';
import { COLORS, SPACING, BORDER_RADIUS, SHADOWS } from '../../constants/theme';

/**
 * LoginPage – shown to unauthenticated users.
 * Triggers Microsoft (Azure AD) sign-in via MSAL redirect flow.
 */
const LoginPage = () => {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const handleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      // Redirect to Microsoft login; the app will reload after consent
      await instance.loginRedirect(loginRequest);
    } catch (err) {
      console.error('[SSO] Login failed:', err);
      setError('Sign-in failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: COLORS.background,
      display: 'flex',
      flexDirection: 'column',
    }}>

      {/* Top bar */}
      <Header />

      {/* Centre card */}
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: SPACING.xxl,
      }}>
        <div style={{
          backgroundColor: COLORS.white,
          border: `1px solid ${COLORS.border}`,
          borderRadius: BORDER_RADIUS.xl,
          boxShadow: SHADOWS.lg,
          padding: `${SPACING.xxxl * 1.5}px ${SPACING.xxxl * 2}px`,
          maxWidth: 420,
          width: '100%',
          textAlign: 'center',
        }}>

          {/* Lock icon */}
          <div style={{
            width: 64, height: 64, borderRadius: BORDER_RADIUS.full,
            backgroundColor: COLORS.lightGray,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto',
            marginBottom: SPACING.xxl,
          }}>
            <McIcon icon="lock" size="24" color={COLORS.text} />
          </div>

          <h1 className="mds-headline--small" style={{ margin: `0 0 ${SPACING.sm}px`, color: COLORS.text }}>
            Sign in to continue
          </h1>
          <p className="mds-text--medium-normal" style={{ margin: `0 0 ${SPACING.xxxl}px`, color: COLORS.textSecondary }}>
            Use your Maersk Microsoft account to access Neurix Lab.
          </p>

          {/* Sign-in button */}
          <McButton
            appearance="primary"
            variant="filled"
            fit="large"
            width="full-width"
            icon={loading ? undefined : 'door-arrow-right-in'}
            loading={loading}
            disabled={loading}
            click={loading ? undefined : handleLogin}
          >
            {loading ? 'Redirecting to Microsoft…' : 'Sign in with Microsoft'}
          </McButton>

          {error && (
            <div style={{ marginTop: SPACING.lg, textAlign: 'left' }}>
              <McNotification appearance="error" icon="exclamation-octagon" body={error} fit="small" />
            </div>
          )}

          <p className="mds-text--x-small-normal" style={{ marginTop: SPACING.xxl, marginBottom: 0, color: COLORS.textSecondary }}>
            Single sign-on powered by Microsoft Azure AD
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;

